<template>
    <div class="container" style="margin-top: 15px; min-height: 600px; height: auto;">
        <div class="row">
            <div class="col-1"></div>
            <div class="col-10">    
                <span class="buy" style="cursor: pointer;" @click="back">返回课程 </span>
                <i class="el-icon-arrow-right"></i>
                <span class="buy" style="cursor: pointer;" @click="goBuy">确认订单 </span>
                <i class="el-icon-arrow-right"></i>
                <span class="buy" style="cursor: pointer;" @click="goConsume">支付课程 </span>
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name:'OrderSystem',
        methods: {
            back() {
                if (this.$route.path !== '/programmes/' + this.$route.params.id) {
                    this.$router.push({
                        name:'programmes',
                        params: {
                            id: this.$route.params.id
                        }
                    })
                }
            }, 
            goBuy() {
                if (this.$route.path !== '/order/buy/' + this.$route.params.id) {
                    this.$router.push({
                        name:'buy',
                        params: {
                            id:this.$route.params.id
                        }
                    })
                }
            },
            goConsume() {
                if (this.$route.path !== '/order/consume/' + this.$route.params.id) {
                    this.$router.push({
                        name:'consume',
                        params: {
                            id:this.$route.params.id
                        }
                    })
                }
            }
        },
        created(){
            console.log("123")
        }
    }
</script>

<style scoped>
.buy {
    text-decoration: none;
    font-size:15px;
    color:black
}
.buy:hover {
    text-decoration: none;
}
.buy:visited {
    text-decoration: none;
}
.buyhover {
    font-size: 18px;
    text-decoration: none;
}
</style>